import { Directive, HostBinding, Input } from '@angular/core';
import * as uuid from 'uuid';

export interface IconInputs {
  height: string;
  width: string;
  color: string;
}

@Directive()
export abstract class BaseIconComponent {
  @HostBinding('style.display') public display = 'inline-flex';

  private _height = '35';

  private _width = 'auto';

  // 'auto' is not a valid <svg> length attribute — templates bind these via
  // [attr.width]/[attr.height], so returning null omits the attribute and the
  // browser derives the same size from the viewBox aspect ratio.
  @Input() public set height(value: string) {
    this._height = value;
  }

  public get height(): string | null {
    return this._height === 'auto' ? null : this._height;
  }

  @Input() public set width(value: string) {
    this._width = value;
  }

  public get width(): string | null {
    return this._width === 'auto' ? null : this._width;
  }

  @Input() public color = 'currentColor';

  id: string = uuid.v4();
}
